export default function Gallery() {
  const images = [
    {
      url: 'https://public.readdy.ai/ai/img_res/fa96f03146e11cf5bae6954548d81532.jpg',
      title: 'Mecanizado CNC',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Industrial%20balancing%20machine%20equipment%20for%20rotating%20components%20in%20professional%20workshop%20environment%20with%20precision%20instruments%20and%20modern%20technology%20showing%20industrial%20engineering%20excellence%20and%20quality%20control&width=600&height=400&seq=gallery-talleres-lujambio-004&orientation=landscape',
      title: 'Equilibrado Industrial',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Large%20industrial%20metal%20component%20being%20straightened%20with%20hydraulic%20press%20equipment%20in%20professional%20manufacturing%20facility%20showing%20heavy%20machinery%20and%20precision%20metalworking%20with%20organized%20workspace&width=600&height=400&seq=gallery-talleres-lujambio-005&orientation=landscape',
      title: 'Enderezado de Piezas',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Industrial%20polishing%20and%20finishing%20equipment%20working%20on%20metal%20surface%20in%20professional%20workshop%20with%20grinding%20machines%20and%20quality%20control%20showing%20precision%20surface%20treatment%20and%20metalworking%20excellence&width=600&height=400&seq=gallery-talleres-lujambio-006&orientation=landscape',
      title: 'Pulido Industrial',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Mechanical%20construction%20and%20assembly%20of%20industrial%20components%20with%20welding%20equipment%20and%20fabrication%20tools%20in%20professional%20workshop%20showing%20structural%20metalwork%20and%20engineering%20precision&width=600&height=400&seq=gallery-talleres-lujambio-007&orientation=landscape',
      title: 'Construcción Mecánica',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Quality%20control%20inspection%20of%20precision%20machined%20industrial%20parts%20with%20measuring%20instruments%20and%20verification%20equipment%20in%20professional%20manufacturing%20environment%20showing%20attention%20to%20detail%20and%20quality%20assurance&width=600&height=400&seq=gallery-talleres-lujambio-008&orientation=landscape',
      title: 'Control de Calidad',
    },
  ];

  return (
    <section id="galeria" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Galería
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Nuestras instalaciones y trabajos realizados
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-80">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6 w-full">
                  <h3 className="text-xl font-bold text-white">{image.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
